module.exports = __webpack_public_path__ + "img/force2.5c4c4c35.png";